// removed by extract-text-webpack-plugin
module.exports = {"amenitiesContainer":"style__amenitiesContainer___1S0kG","amenitiesContainerInner":"style__amenitiesContainerInner___2mIAD","amenitiesContainerTitle":"style__amenitiesContainerTitle___Kmpd0","amenitiesContainerItem":"style__amenitiesContainerItem___25Tff","amenitiesContainerItemIcon":"style__amenitiesContainerItemIcon___2eErd","amenitiesContainerItemText":"style__amenitiesContainerItemText___20njX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/dropdown-amenities/style.css
// module id = 1300
// module chunks = 0